/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const ACC_REC_NDC_ACTIVITY_HEAD = 'ACC_REC_NDC_ACTIVITY_HEAD';
export const ACC_REC_NDC_RESPONSE = 'ACC_REC_NDC_RESPONSE';
export const ACC_REC_NDC_ACTIVITY = 'ACC_REC_NDC_ACTIVITY';
export const ACTIVITY_TYPE_PRINCIPAL = 'ACTIVITY_TYPE_PRINCIPAL';
export const ACTIVITY_TYPE_INTEREST = 'ACTIVITY_TYPE_INTEREST';
export const NDC_ACTIVITY_FIRST_LOAD = 'NDC_ACTIVITY_FIRST_LOAD';
export const ACCOUNT_REC_NDC_ACTIVITY_CLEAR_REDUX =
  'ACCOUNT_REC_NDC_ACTIVITY_CLEAR_REDUX';
